import { observable } from "@legendapp/state";

/**
 * Session-local map: external source URL → footnote index for the current document draft/edit.
 * Avoids rescanning the whole editor HTML on every clip; reset when the edited document changes.
 */
export const documentClipFootnoteSession$ = observable({
  documentKey: "__none__" as string,
  refByNormalizedUrl: {} as Record<string, number>,
});

export function normalizeSourceUrlKey(url: string): string {
  try {
    const u = new URL(url);
    u.hash = "";
    return u.toString();
  } catch {
    return url.trim();
  }
}

export function resetDocumentClipFootnoteSession(documentKey: string): void {
  documentClipFootnoteSession$.set({
    documentKey,
    refByNormalizedUrl: {},
  });
}

export function rememberFootnoteRefForSource(url: string, refNum: number): void {
  const key = normalizeSourceUrlKey(url);
  const cur = documentClipFootnoteSession$.peek();
  documentClipFootnoteSession$.set({
    documentKey: cur.documentKey,
    refByNormalizedUrl: { ...cur.refByNormalizedUrl, [key]: refNum },
  });
}

/** @returns ref number if this URL was already assigned for this document in-session */
export function peekSessionFootnoteRef(documentKey: string, url: string): number | undefined {
  const cur = documentClipFootnoteSession$.peek();
  if (cur.documentKey !== documentKey) return undefined;
  return cur.refByNormalizedUrl[normalizeSourceUrlKey(url)];
}
